export function getAdminDownloadUrl(asset) {
  if (!asset) return null;
  return "".concat((asset === null || asset === void 0 ? void 0 : asset.downloadUrl) || (asset === null || asset === void 0 ? void 0 : asset.webUrl), "?download");
}
export function getPublicDownloadUrl(asset) {
  if ((asset === null || asset === void 0 ? void 0 : asset.type) === 'upload' && ((asset === null || asset === void 0 ? void 0 : asset.download) === 'enabled' || (asset === null || asset === void 0 ? void 0 : asset.download) === 'required')) {
    return getAdminDownloadUrl(asset);
  }
}